import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=5d71e74d&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=5d71e74d&prod&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=5d71e74d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71e74d",
  null
  
)

export default component.exports